module.exports = __webpack_public_path__ + "static/media/drag-city-combined.38bd1667.png";